import { z } from 'zod/v4';
import { Currency } from '../index.js';
import { Lang } from '../lang/Lang.js';
export var ImportSheetType;
(function (ImportSheetType) {
    ImportSheetType["Cases"] = "cases";
    ImportSheetType["Customers"] = "customers";
    ImportSheetType["Vouchers"] = "vouchers";
    ImportSheetType["Creditors"] = "creditors";
    ImportSheetType["UltimateCreditors"] = "ultimateCreditors";
    ImportSheetType["Users"] = "users";
    ImportSheetType["BillingVouchers"] = "billingVouchers";
    ImportSheetType["Notes"] = "notes";
    ImportSheetType["Emails"] = "emails";
    ImportSheetType["Letters"] = "letters";
    ImportSheetType["Sms"] = "sms";
    ImportSheetType["Steps"] = "steps";
    ImportSheetType["Updates"] = "updates";
    ImportSheetType["Documents"] = "documents";
    ImportSheetType["PaymentPlans"] = "paymentPlans";
})(ImportSheetType || (ImportSheetType = {}));
export const ColumnMapSchema = z.record(z.string(), z.array(z.string()));
export const FieldOptionsSchema = z.record(z.string(), z.object({ invertSign: z.boolean().optional() }));
const BuiltinFixedValuesSchema = z
    .object({
    isCompany: z.boolean().optional(),
    customerTerminated: z.boolean().optional(),
    lang: z.enum(Lang).optional(),
    phoneLocale: z
        .string()
        .regex(/^\d{1,3}$/)
        .optional(),
    currency: z.enum(Currency).optional(),
    imposedByCreditor: z.boolean().optional(),
})
    .strict();
export const isFixedPropertyField = (field) => field.startsWith('property_') && field.length > 'property_'.length;
export const FixedValuesSchema = BuiltinFixedValuesSchema.catchall(z.union([z.string(), z.number(), z.boolean()])).superRefine((values, context) => {
    for (const field of Object.keys(values)) {
        if (!Object.hasOwn(BuiltinFixedValuesSchema.shape, field) &&
            !isFixedPropertyField(field)) {
            context.addIssue({
                code: 'custom',
                path: [field],
                message: 'Unsupported fixed value field',
            });
        }
    }
});
export const getFixedValueFields = (type, propertyFields = []) => {
    const properties = propertyFields.filter(isFixedPropertyField);
    switch (type) {
        case ImportSheetType.Cases:
            return [
                'isCompany',
                'lang',
                'phoneLocale',
                'currency',
                'customerTerminated',
                ...properties,
            ];
        case ImportSheetType.Customers:
            return ['isCompany', 'lang', 'phoneLocale', ...properties];
        case ImportSheetType.Vouchers:
            return ['imposedByCreditor', ...properties];
        default:
            return [];
    }
};
export const SheetMappingSchema = z.object({
    sheetName: z.string().min(1),
    type: z.enum(ImportSheetType).nullable(),
    headerRow: z.number().int().positive(),
    map: ColumnMapSchema,
    fieldOptions: FieldOptionsSchema.optional(),
    fixedValues: FixedValuesSchema.optional(),
});
export const SaveImportMappingSchema = z.object({
    importFileId: z.uuid(),
    sheetMappings: z.array(SheetMappingSchema),
});
export const StartImportSchema = z.object({
    allDebtorsTerminated: z.boolean().optional(),
    map: ColumnMapSchema,
    sheetMappings: z.array(SheetMappingSchema).optional(),
});
//# sourceMappingURL=sheet-mapping.js.map